import * as React from "react";
import { forwardRef } from "react";
const SvgIconExpand = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 10, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M.026 2.177c.002-.348.076-.693.217-1.01C.391.823.633.53.938.324A1.9 1.9 0 0 1 1.97 0h9.141a1.9 1.9 0 0 1 1.03.324c.307.206.548.499.696.843a2.38 2.38 0 0 1-.282 2.455l-4.57 5.666a1.85 1.85 0 0 1-.643.525 1.81 1.81 0 0 1-1.603 0 1.85 1.85 0 0 1-.642-.525L.526 3.622a2.32 2.32 0 0 1-.5-1.445" }));
const ForwardRef = forwardRef(SvgIconExpand);
export { ForwardRef as ReactComponent };
